export default __webpack_public_path__ + "static/media/reportsIcon.d8b2facc.svg";